import React, {useEffect, useContext, useState } from "react"
import HttpRequest from "../HttpService";
import axios from "axios";

export const UserProvider = ({ children }) => {

  const [sessionIP, setSessionIP] = useState();
  const [apiVersion, setAPIVersion] = useState("1.1.0");

  useEffect(() => {

    HttpRequest.getAPIVersion().then(async(body)=> {
      try{
        setAPIVersion(body.data.message.substring(body.data.message.indexOf(":") + 1));
      }
      catch(e){console.error("getAPIVersion exception", e)}
    });

    axios.get('https://api.ipify.org/').then((res)=> {
      updateIPAddress(res.data);
    });
  }, []);



  const updateIPAddress = (val) => {
    setSessionIP(val)
  }

  const getIPAddress = () => {
    return sessionIP;
  }

  return (
    <UserContext.Provider value={
      {  
        sessionIP,      
        apiVersion,       
        updateIPAddress,
        getIPAddress
      }
    }>
      {children}
    </UserContext.Provider>
  )
}

const UserContext = React.createContext();
// make sure use
export const useUserContext = () => {
  return useContext(UserContext)
}
